<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col lg="12">
				<b-card>
					<div slot="header">
						<i class='icon-user'></i> Uporabniki
						<div class="card-actions">
							<a href="#dodajUporabnika" class="btn btn-setting" @click.prevent="click_openAddUser"><i class="icon-user-follow"></i></a>
						</div>
					</div>
					<b-table
						ref="dataTable"
						responsive="sm"
						show-empty
						hover
						empty-text="Ni vnosov"
						empty-filtered-text="Ni zadetkov"
						:items="dataProvider"
						:fields="fields"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						@row-clicked="rowClicked">
						<template slot="role" slot-scope="data">
							{{data.item.role | role_hr}}
						</template>
						<template slot="last_access_at" slot-scope="data">
							{{ timestampIzpis(data.item.last_access_at) }}
						</template>
						<template slot="created_at" slot-scope="data">
							{{ timestampIzpis(data.item.created_at) }}
						</template>
						<template slot="actions" slot-scope="data">
							<b-button size="sm" @click.stop="click_removeUser(data, $event.target)" class="mr-2">
								Odstrani
							</b-button>
							<b-button size="sm" @click.stop="click_openEditUser(data, $event.target)" variant="primary" class="mr-2">
								Uredi
							</b-button>
						</template>
					</b-table>
					<nav>
						<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
					</nav>
				</b-card>
				<edit-user-modal ref="editModal" @user_add="edit_add" @user_edit="edit_update" />
			</b-col>
		</b-row>
		<vue-toastr ref="toastr"></vue-toastr>
	</div>
</template>

<script>
import EditUserModal from '@/components/EditUserModal';
import service from '@/service';
import { format } from 'date-fns';
import settings from '@/settings.js';

export default {
	name: 'uporabniki',
	components: {
		'edit-user-modal': EditUserModal
	},
	filters: {
		role_hr: function (value) {
			if (value != null) {
				if (value === 5) {
					return 'Administrator';
				} else if (value === 4) {
					return 'Moderator';
				} else if (value === 3) {
					return 'Računovodja';
				} else if (value === 1) {
					return 'Komercialni sekretar';
				} else if (value === 0) {
					return 'Prodajalec';
				} else if (value === 11) {
					return 'Skrbnik gum';
				} else if (value === 12) {
					return 'Servis';
				} else if (value === 13) {
					return 'Poprodaja';
				} else {
					return 'Neznana vloga';
				}
			} else {
				return 'Neznana vloga';
			}
		}
	},
	methods: {
		rowClicked: function (item, index) {
			this.$refs.editModal.showModal(item);
		},
		click_openAddUser: function () {
			this.$refs.editModal.showModal(null);
		},
		click_openEditUser: function (data, button) {
			this.$refs.editModal.showModal(data.item);
		},
		click_removeUser: function (data, button) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati uporabnika ' + data.item.email + '?', {
				title: 'Potrdite brisanje uporabnika',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					service.removeUser(data.item)
						.then(response => {
							if (response['message'] === 'deleted') {
								this.$refs.dataTable.refresh();
								this.$refs.toastr.s('Uporabnik ' + response['user']['email'] + ' odstranjen');
							} else {
								this.$refs.toastr.e('Neveljaven odziv strežnika!');
								console.error('Neveljaven response message: ' + response.data['message']);
							}
						})
						.catch(error => {
							if (error.response) {
								// Request made and server responded
								if (error.response.data.message === settings.errorMessages.serverSideValidationError) {
									this.$refs.toastr.e('Napaka pri validaciji na strežniku!');
									console.error(error.response.data.message + ': ', error.response.data.errors);
								} else if (error.response.data.message === 'userNotExists') {
									this.$refs.toastr.e('Uporabnik ne obstaja!');
									console.error(error.response.data.message);
								} else if (error.response.data.message === settings.errorMessages.invalidRole) {
									this.$refs.toastr.e('Uporabnik nima pravice odstranjevanja uporabnikov!');
									console.error(error.response.data.message);
								} else if (error.response.data.message === settings.errorMessages.PDOException) {
									this.$refs.toastr.e('Napaka na strežniku!');
									console.error(error.response.data.message, 'details in .ex');
								} else {
									this.$refs.toastr.e('Neznana napaka na strežniku!');
									console.error(error.response.data.message);
								}
							} else if (error.request) {
								// The request was made but no response was received
								console.log('The request was made but no response was received:', error.request);
							} else {
								// Something happened in setting up the request that triggered an Error
								console.log('Something happened in setting up the request that triggered an Error:', error.message);
							}
						});
				}
			}).catch(err => {
				console.log(err);
			})
		},
		edit_add: function (item) {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Uporabnik ' + item.first_name + ' ' + item.last_name + ' dodan');
		},
		edit_update: function (item) {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Uporabnik ' + item.first_name + ' ' + item.last_name + ' posodobljen');
		},
		dataProvider: function (ctx) {
			return service.getUsers(ctx, this.inputFilter)
				.then(data => {
					this.items = data;
					this.totalRows = data.total;
					return this.items.data;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
					return [];
				});
		},
		timestampIzpis: function (timestam) {
			let result = '';
			if (timestam) {
				let datum = format(timestam.substring(0, 10), settings.viewDtFormat);
				let ura = timestam.substring(11, 19);
				result = 'Dne ' + datum + ' ob ' + ura;
			}
			return result;
		}
	},
	data: () => {
		return {
			fields: [
				{ key: 'first_name', label: 'Ime', sortable: true },
				{ key: 'last_name', label: 'Priimek', sortable: true },
				{ key: 'email', label: 'Email', sortable: true },
				{ key: 'role', label: 'Vloga' },
				{ key: 'last_access_at', label: 'Zadnji dostop' },
				{ key: 'last_access_ip', label: 'Ip zadnjega dostopa' },
				{ key: 'actions', label: '#' }
			],
			currentPage: 1,
			perPage: 15,
			totalRows: 0,
			items: [],
			filter: null
		};
	}
};
</script>



// WEBPACK FOOTER //
// src/views/Uporabniki.vue